import { useCallback, useContext, useState } from 'react';
import { svgSprite } from '../../../../../../hybrid/wrappers';
import FormButtons from '../../../../../../widgets/form/form-control-buttons/FormButtons/FormButtons';
import ChangeEmail from '../ChangeEmail/ChangeEmail';
import UserContext from '../../../../../../common/utils/getContext';
import Timer from '../../timer/Timer';
import { sendEmailFunc } from '../helpers';
import { useRouter } from 'next/router';
import T from '../../../../../../common/components/T';
import css from './VerifyEmail.module.scss';

const VerifyEmail = ({ setStepData, data, timerDate, counterValue }) => {
    const router = useRouter();
    const type = router?.query?.type;
    const { lang, setAlertData } = useContext(UserContext);
    const [counter, setCounter] = useState(counterValue || timerDate ? 3 : 0);
    const [timer, setTimer] = useState(timerDate || false);
    const [pending, setPending] = useState(false);
    const sendEmail = useCallback(() => {
        if (pending) return;
        sendEmailFunc(data, counter, setCounter, setTimer, setPending, lang, setAlertData);
    }, [counter, lang, pending, setAlertData, data]);

    const setChangeEmail = useCallback(() => {
        setStepData((pre) => ({
            component: ChangeEmail,
            props: { setStepData, data },
            back: {
                ...pre,
                props: {
                    ...pre.props,
                    timerDate: timer,
                    counterValue: counter
                }
            }
        }));
    }, [setStepData, data, timer, counter]);

    return (
        <>
            <div className={css.authHeading}>
                <div className={css.authHeadingInsideBlock}>
                    <div className={css.authIconCompleet}>
                        {svgSprite(type === 'login' ? 'envelope-opened-cross' : 'check-circle-thin', {
                            width: '80',
                            height: '80',
                            fill: type === 'login' ? 'var(--greyExtraDarkColor)' : 'var(--greenColor)'
                        })}
                    </div>
                    <p className={css.authHeadingTitle}>
                        {type === 'login' ? (
                            <T
                                page='/authentication'
                                textName='confirm-auth-Verifi-alert-2'
                                defaultStr='Ваш e-mail не верифицирован!'
                            />
                        ) : (
                            <>
                                <T
                                    page='/authentication'
                                    textName='confirm-auth-Verifi-alert-1'
                                    defaultStr='Благодарим за регистрацию!'
                                />
                                <T
                                    page='/authentication'
                                    textName='confirm-auth-Verifi-alert-3'
                                    defaultStr='Подтвердите свой e-mail'
                                />
                            </>
                        )}
                    </p>
                    <p className={css.authHeadingText}>
                        {type === 'login' ? (
                            <T
                                page='/authentication'
                                textName='confirm-auth-Verifi-text-1'
                                defaultStr='Чтобы перейти к личному кабинету, подтвердите свой e-mail'
                            />
                        ) : (
                            <T
                                page='/authentication'
                                textName='confirm-auth-Verifi-text-2'
                                defaultStr='Чтобы перейти в личный кабинет, необходимо верифицировать e-mail'
                            />
                        )}
                    </p>
                </div>
            </div>
            <div className={css.authHeadingInfo}>
                <p className={css.authHeadingInfoText}>
                    <T
                        page='/authentication'
                        textName='confirm-auth-Verifi-info'
                        defaultStr='Письмо для подтверждения уже было отправлено на'
                    />
                </p>
                <p className={css.authHeadingInfoLink}>{data.userData.email}</p>
            </div>
            <FormButtons
                customFormButton={{ isFullWidth: true }}
                sendFormData={setChangeEmail}
                buttonText={
                    <T
                        page='/authentication'
                        textName='confirm-auth-Verifi-button'
                        defaultStr='Указали неверный адрес? Изменить e-mail'
                    />
                }
            />
            {timer ? (
                <Timer
                    onExpire={() => {
                        setCounter(2);
                        setTimer(false);
                    }}
                    time={timer}
                />
            ) : (
                <button onClick={sendEmail} className={css.authHeadingRepeatLink}>
                    <T page='/authentication' textName='confirm-auth-Verifi-repeat' defaultStr='Отправить письмо повторно' />
                </button>
            )}
        </>
    );
};
export default VerifyEmail;
